export const formatIncludedExtras = (includedExtras) => {
    const extrasArray = includedExtras
        ? includedExtras
            .map(({ includedExtraName }) => includedExtraName)
            .join(', ')
        : '';
    return extrasArray;
};
export const getPropertyImageWidth = ({ url, imageWidth, }) => {
    const awazeDefaultWidth = 840;
    const novasolDefaultWidth = 600;
    const isNovasolImage = Boolean(url);
    const defaultImageWidth = isNovasolImage
        ? novasolDefaultWidth
        : awazeDefaultWidth;
    return imageWidth || defaultImageWidth;
};
export function shouldAddImageAttribute(numberImages, index) {
    return numberImages > 0 && index < numberImages;
}
//# sourceMappingURL=property-list.utils.js.map